import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Table } from "react-bootstrap";
import * as React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CurrencyFormat from "react-currency-format";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function SalesOrderDetailsTable(props) {
  return (
    <>
      <div className="">
        <TableContainer className="w-full bg-white">
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <colgroup>
              <col style={{ width: "35%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "15%" }} />
            </colgroup>
            <TableHead style={{ backgroundColor: "#FAFAFA" }}>
              <TableRow>
                <TableCell className="!text-[10px] !font-bold !uppercase !tracking-widest !text-gray-500 !py-3">Items Details</TableCell>
                <TableCell className="!text-[10px] !font-bold !uppercase !tracking-widest !text-gray-500 !py-3">SKU</TableCell>
                <TableCell className="!text-[10px] !font-bold !uppercase !tracking-widest !text-gray-500 !py-3">Quantity</TableCell>
                <TableCell className="!text-[10px] !font-bold !uppercase !tracking-widest !text-gray-500 !py-3">Weight</TableCell>
                <TableCell className="!text-[10px] !font-bold !uppercase !tracking-widest !text-gray-500 !py-3">Rate</TableCell>
                <TableCell className="!text-[10px] !font-bold !uppercase !tracking-widest !text-gray-500 !py-3">Tax</TableCell>
                <TableCell className="!text-[10px] !font-bold !uppercase !tracking-widest !text-gray-500 !py-3">Total Amount</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {props?.tableData?.map((item, i) => {
                return (
                  <TableRow
                    key={i}
                    className="hover:bg-gray-50/50 transition-colors"
                  >
                    <TableCell className="!py-3 !text-sm !font-medium !text-gray-700">
                      {item.item_name}
                    </TableCell>
                    <TableCell className="!py-3 !text-sm !text-gray-500 font-mono">
                      {item.item_sku} 
                    </TableCell>
                    <TableCell className="!py-3 !text-sm !font-bold !text-gray-900">
                      {formatCustomNumber(item.item_sales_quantity)} 
                    </TableCell>
                    <TableCell className="!py-3 !text-sm !text-gray-500">
                      {item.sales_order_item_weight_description || "—" } 
                    </TableCell>
                    <TableCell className="!py-3 !text-sm !font-medium !text-gray-700">
                      <CurrencyFormat
                        value={formatCustomNumber(item.item_sales_rate)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"₦"}
                      />
                    </TableCell>

                    <TableCell className="!py-3 !text-xs !font-semibold">
                      {item?.Item_Tax_Name ? (
                        <span className="px-2 py-0.5 bg-blue-50 text-blue-600 rounded-full border border-blue-100">
                           {item?.Item_Tax_Name}
                        </span>
                      ) : <span className="text-gray-300">—</span>}
                    </TableCell>

                    <TableCell className="!py-3 !text-sm !font-bold !text-gray-900">
                      <CurrencyFormat
                        value={formatCustomNumber(item.item_sales_rate * item.item_sales_quantity)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"₦"}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}

export default SalesOrderDetailsTable;
